import { embedTag } from './embed.tag'
import { createApp } from './embed.app'
import { AppParams } from './interfaces'

const tag = document.querySelector('script[client-id], #xund-app-placeholder') as HTMLScriptElement | null

if (tag?.getAttribute('client-id')) {
  embedTag(tag)
} else {
  Object.assign(window, { XUND: { hc: { init: async (params: AppParams) => await createApp(params) } } })
}
